import React from 'react'
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { useAuth } from '../contexts/auth';

export default function LoginForm() {

    const { user, login, logout } = useAuth();


    const handleSubmit = (e: any) => {
        // Prevent page reload

        e.preventDefault();
        login(e.target[0].value, e.target[1].value)

    };

    return (

        <>

            <form onSubmit={handleSubmit} className='container-sm'>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="email" aria-describedby="emailHelp" />
                    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input type="password" className="form-control" id="exampleInputPassword1" />
                </div>
                <button className="btn btn-dark  active">
                    Login
                </button>
            </form>

        </>
        // <form onSubmit={handleSubmit}>
        //     <div >
        //         <label
        //             htmlFor="email"

        //         >
        //             Email
        //         </label>
        //         <input
        //             type="email"
        //             defaultValue={''}
        //         />
        //     </div>
        //     <div >
        //         <label
        //             htmlFor="password"
        //         >
        //             Password
        //         </label>
        //         <input
        //             type="password"
        //             defaultValue={''}
        //         />
        //     </div>

        //     <div >
        //         <button
        //         >
        //             Login
        //         </button>
        //     </div>
        // </form>
    )
}
